import {request} from '@/network/request'
export function getBershuraMountainsBc(query) {
    return request({
        url: '/gaoligong/bershuramountains/getBershuraMountainsBc',
        method: 'get',
        params: query
    })
}
